import React from "react";
import { ProductCard } from "./components/product-card";

export const ProductList = ({ state, dispatch }) => {
  return state.items.map((item) => <ProductCard key={item.price_id} {...item} state={state} dispatch={dispatch} />);
};
